import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useState } from "react";
import { Macro } from "../../../../../../../services/macros/types/macros";
import { createMacro, updateMacro } from "../../../../sdk/macros";
import { cleanUpShortcut } from "../../../../utils/cleanup-shortcut";

interface ManageDialogProps extends Omit<DialogProps, "open"> {
  show: boolean;
  macro?: Macro;
  onSave: () => void;
  onClose: () => void;
}
export const ManageMacroDialog: React.FC<ManageDialogProps> = ({
  onSave,
  onClose,
  ...props
}) => {
  const [title, setTitle] = useState(props.macro?.title ?? "");
  const [shortcut, setShortcut] = useState(
    cleanUpShortcut(props.macro?.shortKey ?? "")
  );
  const [message, setMessage] = useState(props.macro?.message ?? "");
  const [id] = useState(props.macro?.id);

  const [loading, setLoading] = useState(false);

  const [open] = useState(props.show);

  const saveMacro = (payload: Omit<Macro, "id">) => {
    createMacro(payload)
      .then(() => {
        onSave();
        onClose();
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  const editMacro = (id: string, payload: Omit<Macro, "id">) => {
    updateMacro(id, payload)
      .then(() => {
        onSave();
        onClose();
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  const handleSave = (id: string | undefined = undefined) => {
    const payload: Omit<Macro, "id"> = {
      message,
      shortKey: `;${cleanUpShortcut(shortcut)}`,
      title,
    };

    setLoading(true);

    if (id) {
      editMacro(id, payload);
    } else {
      saveMacro(payload);
    }
  };
  return (
    <React.Fragment>
      <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Subscribe</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="title"
            label="Title"
            type="text"
            value={title}
            onChange={(ev) => setTitle(ev.target.value)}
            fullWidth
          />
          <TextField
            margin="dense"
            id="shortcut"
            label="Shortcut"
            type="text"
            value={cleanUpShortcut(shortcut)}
            onChange={(ev) => setShortcut(ev.target.value)}
            fullWidth
          />
          <TextField
            margin="dense"
            id="message"
            label="Message"
            type="text"
            value={message}
            onChange={(ev) => setMessage(ev.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleSave(id);
            }}
            color="primary"
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : id ? (
              "Update"
            ) : (
              "Create"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
